import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Wrapper from "./esignForm.styles";
import { isIE11 } from "@utils/helpers/browserHelper";
import esignGraphic from "@theme/assets/icon-eSign.png";
import AcceptContractScheduleCheckbox from "../components/acceptContractScheduleCheckbox";
import { UnStyledButton } from "@components/textButton";
import cx from "classnames";
import { getValidationErrorMessage } from "@utils/helpers/esignHelpers";
import {
  smsName,
  acceptContractAndSchedule,
  FORM_ID_ESIGN,
} from "../../../constants/commonConstants";
import EsignOtpInput from "./esignOtpInput";
import environmentSettings from "@src/constants/environmentSettings";

const EsignForm = ({
  isSubmitting,
  values,
  errors,
  touched,
  handleChange,
  submitForm,
  handleBlur,
  setFieldValue,
  setChecboxChecked,
  checkboxChecked,
}) => {
  const errorMessage = getValidationErrorMessage(touched, errors);

  const isDisabled = checkboxChecked === false;
  const [otp, setOtp] = useState("");
  const onChange = useCallback((value) => setOtp(value), [setOtp]);

  const { phone } = environmentSettings;

  const ieSubmit = useCallback(() => {
    if (isIE11) {
      (() => submitForm())();
    }
  }, [submitForm]);

  useEffect(() => {
    setChecboxChecked(values.acceptContractAndSchedule ? true : false);
    setFieldValue("sms", otp);
  }, [values, setChecboxChecked, otp, setFieldValue]);

  return (
    <Wrapper>
      <h1 className="sms-title">eSign Your Contract</h1>
      <img className="animated-gif-esign" src={esignGraphic} alt="esign" />
      <AcceptContractScheduleCheckbox
        onChange={handleChange}
        onBlur={handleBlur}
        checked={values[acceptContractAndSchedule]}
        name="acceptContractAndSchedule"
        setFieldValue={setFieldValue}
      />
      <div className="input-group">
        <p className="sms-title">Enter 6-digit eSign code here</p>
        <EsignOtpInput
          value={otp}
          valueLength={6}
          onChange={onChange}
          isDisabled={isDisabled}
          name={smsName}
        />
        {errorMessage && <p className="sms-error">{errorMessage}</p>}
          <UnStyledButton
            submitForm={ieSubmit}
            isFetching={isSubmitting}
            type="submit"
            form={FORM_ID_ESIGN}
            disabled={isDisabled}
            className={cx("esign-button", { disabled: isDisabled })}
          >
            {`eSign Now`}
          </UnStyledButton>
      </div>
      <p className="please-call-text">
        CHECK YOUR SMS SPAM FOLDER. If you did not receive a code on your
        mobile, please call <strong>{phone}</strong> and quote your
        application number.
      </p>
    </Wrapper>
  );
};

export default EsignForm;

EsignForm.propTypes = {
  isSubmitting: PropTypes.bool,
  values: PropTypes.shape({
    acceptContractAndSchedule: PropTypes.bool
  }),
  errors: PropTypes.any,
  touched: PropTypes.any,
  handleChange: PropTypes.func,
  submitForm: PropTypes.any,
  handleBlur: PropTypes.func,
  setFieldValue: PropTypes.func,
  setChecboxChecked: PropTypes.func,
  checkboxChecked: PropTypes.bool,
}
